export default "__VITE_ASSET__CK5RG670__"